<template>
    <div class="left-panel">
        <div class="profile-header">
            <div class="profile-header-userinfo">
                <img :src="avatar" class="profile-avatar" />
                <div class="header-name">{{ userName }}</div>
            </div>
            <div class="profile-header-statistics">
                <!-- <div class="collect">
                    <span class="num">{{ collectNum }}</span>
                    <span class="desc">收藏</span>
                </div>
                <div class="divide-line" />
                <div class="concern">
                    <span class="num">{{ concernNum }}</span>
                    <span class="desc">关注</span>
                </div> -->
            </div>
        </div>
        <el-scrollbar class="profile-menu">
            <el-menu
                :default-active="currentMenu"
                class="menu"
                active-text-color="#FFF"
            >
                <el-menu-item
                    v-for="menu in menuList"
                    :key="menu.type"
                    :index="menu.type"
                    class="menu-item-row-1"
                    @click="onMenuClick(menu)"
                >
                    <template slot="title">
                        <i :class="menu.icon" class="menu-item-icon" />
                        <span>{{ menu.title }}</span>
                    </template>
                </el-menu-item>
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { Menu, MenuItem, Scrollbar } from 'element-ui';

export default {
    components: {
        'el-menu': Menu,
        'el-menu-item': MenuItem,
        'el-scrollbar': Scrollbar,
    },
    computed: {
        ...mapState({
            avatar: state => state.userInfo.avatar,
            userName: state => state.userInfo.username,
            concernNum: state => state.userInfo.concernNum,
            collectNum: state => state.userInfo.collectNum,
        }),
        menuList() {
            const menuArr = [
                {
                    title: '考前辅导',
                    type: 'learningEdu',
                    icon: 'safety-icon-peixun1',
                },
                {
                    title: '申请考试',
                    type: 'applyExam',
                    icon: 'safety-icon-peixun1',
                },
                // {
                //     title: '考试缴费',
                //     type: 'payments',
                //     icon: 'safety-icon-peixun1',
                // },
                {
                    title: '人脸录入',
                    type: 'inputFace',
                    icon: 'safety-icon-peixun1',
                },
                {
                    title: '申请发票',
                    type: 'applyBill',
                    icon: 'safety-icon-peixun1',
                },
                {
                    title: '继续教育',
                    type: 'adultEdu',
                    icon: 'safety-icon-peixun1',
                },
                {
                    title: '学时证明',
                    type: 'credit',
                    icon: 'safety-icon-peixun1',
                },
                {
                    title: '修改密码',
                    type: 'ChangePsd',
                    icon: 'safety-icon-peixun1',
                },
            ];
            return menuArr;
        },
    },
    data(){
        return {
            currentMenu: 'learningEdu'
        }
    },
    methods: {
        onMenuClick(menu) {
            this.currentMenu = menu.type
            this.$emit('changeComponet', menu.type)
        },
    },
};
</script>


<style lang="scss" scoped>
.left-panel {
    width: 200px;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    .profile-header {
        height: 180px;
        background-color: #fff;
    }
    .profile-menu {
        flex: 1;
        margin-top: 5px;
        background-color: #fff;
        // overflow-y: auto;
        .menu {
            height: 100%;
            border-right: none;
            .menu-item-icon {
                display: inline-block;
                width: 26px;
            }
            ::v-deep .el-menu-item.is-active {
                background-color: #6696ff !important;
            }
        }
    }
    .profile-header-statistics {
        position: relative;
        display: flex;
        margin: 15px auto 0;
        height: 40px;
        .collect {
            width: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .concern {
            width: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .collect .num,
        .concern .num {
            color: #4C85FF;
            font-size: 18px;
        }
        .collect .desc,
        .concern .desc {
            margin-top: 5px;
            color: #808080;
            font-size: 12px;
        }
        .divide-line {
            width: 1px;
            background: linear-gradient(
                rgba(0, 0, 0, 0) 0%,
                #ddd 50%,
                rgba(0, 0, 0, 0) 100%
            );
        }
    }
    .profile-header-userinfo {
        margin-top: 20px;
        .profile-avatar {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            margin: 0 auto;
            background-color: #eee;
            display: block;
        }
        .header-name {
            margin-top: 10px;
            text-align: center;
            font-size: 14px;
            color: #454545;
            font-weight: bold;
        }
    }
}
::v-deep .el-scrollbar__wrap {
    overflow: auto;
}
.el-scrollbar__view {
    height: 100%;
}
</style>
